import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AnimatedNumber from 'react-animated-number';
import muiThemeable from 'material-ui/styles/muiThemeable';
import RaisedButton from 'material-ui/RaisedButton';
// App
import './StepService.css';
import ServiceCategory from './components/ServiceCategory';

class StepService extends Component {

    static propTypes = {
        coiffure: PropTypes.bool,
    };

    static defaultProps = {
      coiffure: false,
    };

    /**
     * Event triggered when a service is checked/unchecked
     *
     * @param {String} service
     * @param {String} serviceCategory
     * @param event
     * @param {Boolean} isInputChecked
     */
    onCheckService = (service, serviceCategory, event, isInputChecked) => {
        const newCheckedServices = _.merge({}, this.props.formData.checkedServices, {
            [serviceCategory]: {
                [service]: isInputChecked
            }
        });

        this.props.onSetFormData({
            checkedServices: newCheckedServices
        });
    };

    /**
     * Return services quantity
     *
     * @returns {number}
     */
    getServicesNumber() {
        let number = 0;

        Object.keys(this.props.formData.checkedServices).forEach(serviceKey => {
            Object.keys(this.props.formData.checkedServices[serviceKey]).forEach(subServiceKey => {

                if (this.props.formData.checkedServices[serviceKey][subServiceKey]) {
                    number++;
                }
            });
        });

        return number;
    }

    /**
     * Return total checked services price in Euro
     *
     * @returns {number}
     */
    getServicesTotalPrice() {
        let price = 0;

        Object.keys(this.props.formData.checkedServices).forEach(serviceKey => {
            Object.keys(this.props.formData.checkedServices[serviceKey]).forEach(subServiceKey => {

              // If services is checked
                if (this.props.formData.checkedServices[serviceKey][subServiceKey]) {
                  // If service exists (already loaded)
                  if (this.props.services[serviceKey] && this.props.services[serviceKey].services[subServiceKey]) {
                    // Add service price to total
                    price += parseFloat(this.props.services[serviceKey].services[subServiceKey].price);
                  }
                }
            });
        });

        return price;
    }

    isServiceChecked(serviceCategory, service) {
        if (!this.props.formData.checkedServices[serviceCategory]) {
            return false;
        }

        if (!this.props.formData.checkedServices[serviceCategory][service]) {
            return false;
        }

        return this.props.formData.checkedServices[serviceCategory][service];
    }

    renderServices() {
        let content = [];

        Object.keys(this.props.services).forEach(serviceKey => {
          // Add category only if more than one service
          if (Object.keys(this.props.services[serviceKey].services).length > 0) {
            content.push(
              <ServiceCategory
                key={serviceKey}
                service={this.props.services[serviceKey]}
                coiffure={this.props.coiffure}
                showPrices={this.props.showPrices}
                checkedServices={this.props.formData.checkedServices[serviceKey]}
                onCheckService={this.onCheckService}
              />
            );
          }
        });

        return content;
    }

    render() {
        let totalPrice = '';

        if (this.props.showPrices) {
            totalPrice = [<div
                            className="step-service-number-container"
                            style={{
                                color: this.props.muiTheme.palette.accent1Color
                            }}
                            >
                            <AnimatedNumber
                                component="text"
                                value={this.getServicesTotalPrice()}
                                stepPrecision={2}
                                duration={250}
                                formatValue={n => n.toFixed(2)}
                                className="step-service-number"
                            />
                            <span className="step-service-number-currency"> €</span>
                        </div>];
        } 

        return (
            <div>
                <div className="step-service-title">
                    Choisissez un service
                </div>
                <div className="step-service-content">
                    {this.renderServices()}
                </div>
                
                { totalPrice }

                <div className="step-service-footer">
                    <RaisedButton
                        label='Suivant'
                        primary={true}
                        disabled={this.getServicesNumber() <= 0}
                        onClick={this.props.handleNext}
                    />
                </div>
            </div>
        )
    }
}

export default muiThemeable()(StepService);


// WEBPACK FOOTER //
// ./src/StepService.js